import { useChannel } from '../../hooks/store/useChannelHooks';
import { CcmChannelMembers } from './CcmChannelMembers';
import { ProviderChannelMembers } from './ProviderChannelMembers';
import { Box } from '@mui/material';
import { MessagingActionHeader } from '../MessagingActionHeader';
import { Routes } from '@xolv-mybrightlink/common';

type ChannelMemberProps = {
  channelGuid: string;
  standalone?: boolean;
  onClose?: () => void;
};

export const ChannelMembers = (props: ChannelMemberProps) => {
  const { channelGuid, standalone, onClose } = props;
  const channel = useChannel(channelGuid);
  if (!channel) {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <MessagingActionHeader
        standalone={standalone}
        channelGuid={channelGuid}
        titleId='care-team.members'
        onClose={onClose}
        expandRoute={Routes.messages.channel.members(channelGuid)}
      />
      {channel.type === 'CARE_TEAM' ? (
        <CcmChannelMembers channelGuid={channelGuid} />
      ) : (
        <ProviderChannelMembers channelGuid={channelGuid} />
      )}
    </Box>
  );
};
